module.exports = __webpack_public_path__ + "img/calendar2.c05e67d0.svg";